import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import styled from "styled-components";
import BREAKPOINTS from "../../constants/breakpoints";
import BreakpointContext from "../../contexts/breakpointContext";
import useAdminMode from "../../hooks/useAdminMode";
import useCurrentUser from "../../hooks/useCurrentUser";
import NavTopLink from "./NavTopLink";
import Paths from "../../util/paths";
import TeamLinksDropdown from "./TeamLinksDropdown";
import { toggleAdminModeOn, toggleAdminModeOff } from "../../store/slices/auth";

const StyledUserLinksLi = styled.li`
  flex: 1 0 auto;

  & > ul {
    justify-content: flex-end;
  }

  @media (min-width: ${BREAKPOINTS.sm}px) {
    flex: 0 1 auto;
  }
`;

const NavTopUserLinks = () => {
  const dispatch = useDispatch();
  const breakpoints = useContext(BreakpointContext);
  const currentUser = useCurrentUser();
  const adminMode = useAdminMode();

  let paths;

  let userPath = "";
  let username = null;
  if (currentUser.obj.isLoggedIn) {
    username = currentUser.obj.username;
    paths = new Paths({ username: username });
    userPath = paths.get("userHome");
  }

  const handleAdminMode = (event) => {
    if (currentUser.isAdmin()) {
      if (event.target.checked) {
        dispatch(toggleAdminModeOn());
      } else {
        dispatch(toggleAdminModeOff());
      }
    }
  };

  console.log("adminMode", adminMode);

  return (
    <StyledUserLinksLi className={"flex-lg"}>
      <ul className={"flex"}>
        {currentUser.obj.isLoggedIn ? (
          <>
            {currentUser.isAdmin() && (
              <>
                <li>{breakpoints.message()}</li>
                <li>
                  <Link to={"/admin"}>Admin</Link>
                </li>
                <li>
                  <input
                    type={"checkbox"}
                    onChange={handleAdminMode}
                    checked={adminMode}
                  />
                </li>
              </>
            )}
            <li>
              <TeamLinksDropdown />
            </li>
            <li>
              <NavTopLink link={userPath} label={username} />
            </li>
            <li>
              <NavTopLink link={"/logout"} label={"Log out"} />
            </li>
          </>
        ) : (
          <>
            {/*<li>*/}
            {/*  <NavTopLink link={"/sign-up"} label={"Sign up"} />*/}
            {/*</li>*/}
            <li>
              <NavTopLink link={"/login"} label={"Log in"} />
            </li>
          </>
        )}
      </ul>
    </StyledUserLinksLi>
  );
};

export default NavTopUserLinks;
